import { generateEventsDefinition } from '@guiker/event'

import { NEWProperty, NEWPropertyOwnership } from '../../entity'
import { baseEvent } from '../base'

type SyncedEventData = {
  legacyId: number
  propertyOwnership: NEWPropertyOwnership
}

const basePropertyEvent = {
  ...baseEvent,
  entity: 'PROPERTY',
  data: null as unknown as NEWProperty,
}

export const PropertyEventsDefinition = generateEventsDefinition({
  ...basePropertyEvent,
  eventTypes: {
    SYNCED: {
      type: 'SYNCED',
      eventData: null as SyncedEventData,
    },
    CREATION_DRAFTED: 'CREATION_DRAFTED',
    CREATION_COMPLETED: 'CREATION_COMPLETED',
    PUBLISHED: 'PUBLISHED',
    UNPUBLISHED: 'UNPUBLISHED',
    BUILDING_UPDATED: 'BUILDING_UPDATED',
    OCCUPANCY_UPDATED: 'OCCUPANCY_UPDATED',
  } as const,
})

export const Events = PropertyEventsDefinition.events
export const EventTypes = PropertyEventsDefinition.eventTypes
export type PropertyEventTypes = typeof EventTypes
